namespace Gordic.Adm.WebControls {
    export interface IGAdmDetailOptions {
        contentName: string;
        data: any;
        currentFilter?: any,
        gridRc?: Gordic.Components.GridRC<any>,
        createPreviousAndNextAction?: boolean,
        newRecord: boolean,
        dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        addPlatnost?: boolean,
        addAktivita?: boolean,
        contentCaption: string,
    }

    export const OptionsDetailDefaults: IGAdmDetailOptions = {
        createPreviousAndNextAction: true,
        contentName: "",
        data: null,
        newRecord: false,
        dataListDescription: {},
        addPlatnost: false,
        addAktivita: true,
        contentCaption: "",
        currentFilter: undefined,
        gridRc: undefined
    }
}